import { useMediaQuery } from 'app/helpers/useMediaQuery';
import { useThemeContext } from 'app/theme/useThemeContext';

export const useIsMobile = () => {
  const theme = useThemeContext();
  return useMediaQuery(theme.breakpoints.down('sm'));
};
